
import { mutations } from '@/assets/scripts/store'

export default {
  name: 'DetailNews',

  data() {
    return {
      shareData: { ready: false },
    }
  },

  head() {
    return this.popinData ? this.popinData.metaTags : null
  },

  computed: {
    popinData: mutations.getPopinData,
  },

  watch: {
    popinData() {
      this.updateShareData()
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.updateShareData()
    })
  },

  methods: {
    updateShareData() {
      if (this.popinData && this.popinData.metaTags) {
        this.shareData.title = this.popinData.metaTags.title
        this.shareData.description = this.popinData.metaTags.meta.find(
          (m) => m.hid === 'description'
        ).content
        this.shareData.location =
          typeof window !== 'undefined' ? window.location.href : null
        this.shareData.ready = true
      }
    },
  },
}
